import StatContainer from './StatContainer';

export default StatContainer;
